import ContentAsset from "@components/BasicComponents/ContentAsset/ContentAsset"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import CurveSection from "@components/Pages/OneFree/CurveSection"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {AdvancedSideAssetModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./HighlightFeatures.module.scss"

type Props = {
	list?: AdvancedSideAssetModuleType
	section?: AdvancedSideAssetModuleType
}

const HighlightFeatures = ({list, section}: Props) => {
	return (
		<>
			<ContainerWrapper
				style={{
					top: "-11px",
					background: "white",
					position: "relative",
				}}
			>
				<Separator size={128} />
				<Typography
					variant={Variant.SectionTitle}
					fontWeight={500}
					// size={Size.XL}
					noPadding
					style={{
						letterSpacing: "-0.5px",
						maxWidth: "1023px",
					}}
					content={section?.mainContent?.[0]?.title}
				/>
				<Separator size={32} />
				<Typography
					variant={Variant.Description}
					noPadding
					size={Size.S}
					content={section?.mainContent?.[0]?.content}
					fontWeight={300}
					style={{
						maxWidth: "1023px",
						// margin: "0 auto",
					}}
				/>
				<Separator size={128} />
				<Separator size={64} />
				<ContentAsset
					data={list?.mainContent?.[0]}
					mainContainerClass={styles.mainContainerClass}
					direction={"left"}
					contentProps={{
						titleProps: {
							style: {
								// color: "#175EEB",
								letterSpacing: "-0.5px",
							},
							size: Size.XL,
						},
						contentProps: {
							size: Size.S,
							fontWeight: 300,
						},
					}}
				/>
				<Separator size={256} />
			</ContainerWrapper>
			<ContainerWrapper>
				<CurveSection className={`${styles.curveSection}`}>
					<ContentAsset
						data={list?.mainContent?.[1]}
						direction={"right"}
						mainContainerClass={`${styles.mainContainerClassCurve} ${styles.mainContainerClass}`}
						contentProps={{
							titleProps: {
								style: {
									// color: "#175EEB",
									letterSpacing: "-0.5px",
								},
								size: Size.XL,
							},
							contentProps: {
								size: Size.S,
								fontWeight: 300,
							},
						}}
					/>
				</CurveSection>
			</ContainerWrapper>
			<ContainerWrapper>
				<Separator size={128} />
				<ContentAsset
					data={list?.mainContent?.[2]}
					mainContainerClass={`${styles.mainContainerClass}`}
					direction={"left"}
					contentProps={{
						titleProps: {
							style: {
								// color: "#175EEB",
								letterSpacing: "-0.5px",
							},
							size: Size.XL,
						},
						contentProps: {
							size: Size.S,
							fontWeight: 300,
						},
					}}
				/>
			</ContainerWrapper>
		</>
	)
}

export default HighlightFeatures
